// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"a834de23","728":"421b0369","819":"3bf39b9b","833":"d7390cf6","935":"d7c6eb5d"}[chunkId] + ".chunk.js";
};